import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/team',
  component: Layout,
  name: 'teamManagement',
  meta: {
    title: '团队管理',
    icon: 'i-ep:office-building',
    menu: false,
  },
  children: [
    {
      path: 'list',
      name: 'teamList',
      component: () => import('@/views/team/index.vue'),
      meta: {
        title: '团队列表',
        icon: 'i-ep:office-building',
      },
    },
    {
      path: 'gifts',
      name: 'teamGiftRecords',
      component: () => import('@/views/team/gifts.vue'),
      meta: {
        title: '套餐赠送记录',
        icon: 'i-ep:document',
      },
    },
  ],
}

export default routes
